<template>
    <!-- NOTE - 
    FIXME -
    NOTE -
    FIXME -
    NOTE -
    TODO - You also need to update the Subscribe.vue page to add the new custom packages, updating this script isn't the only thing you need to do
    -->
    <div v-if="checkIfIsInArrayOfAffiliates()">
        <div class="alert alert-custom alert-white gutter-b" role="alert">
            <div class="alert-icon">
                <i class="fas fa-check-circle text-warning"></i>
            </div>
            <div class="alert-text">
                <h4 class="text-warning">Referral Bonus</h4>
                <p>
                    <!-- NOTE - HeyDominik Message -->
                    <template v-if="currentUser.referralBy == 664">
                        You signed up using HeyDominik's referral code. As a thank you, you'll get
                        <span class="font-weight-bolder">double</span> the amount of Hashtag
                        Performance Campaigns, for free!
                    </template>

                    <!-- NOTE - MajedPhotos message -->
                    <template v-if="currentUser.referralBy == 31847">
                        Thank you for registering using Majed Photo’s affiliate link, enjoy an
                        additional
                        <span class="font-weight-bolder">10€ discount</span> (on top of the normal
                        discount!) on the 6-month and 12-month packages!
                    </template>

                    <!-- NOTE - ValentinDimitrov message -->
                    <template v-if="currentUser.referralBy == 23425">
                        Thank you for registering using Valentin Dimitrov’s affiliate link, enjoy an
                        additional
                        <span class="font-weight-bolder">10€ discount</span> (on top of the normal
                        discount!) on the 6-month and 12-month packages!
                    </template>

                    <!-- NOTE - Referral by Jord Hammond -->
                    <template v-if="currentUser.referralBy == 27331">
                        Thank you for registering using Jord Hammond’s affiliate link, enjoy an
                        additional
                        <span class="font-weight-bolder">20% discount</span> on all Hashtastic
                        packages!
                    </template>

                    <!-- NOTE - Referral by MonicaJ aka Flawfullyyours -->
                    <template v-if="currentUser.referralBy == 25620">
                        Thank you for registering using MonicaJ’s affiliate link, enjoy an
                        additional
                        <span class="font-weight-bolder">20% discount</span> on all Hashtastic
                        packages!
                    </template>

                    <!-- NOTE - Referral by Javier Somoza -->
                    <template v-if="currentUser.referralBy == 75283">
                        Thank you for registering using Javier Somoza's affiliate link, enjoy an
                        additional
                        <span class="font-weight-bolder">20% discount</span> on all Hashtastic
                        packages!
                    </template>

                    <!-- NOTE - Referral by Shauna Davis -->
                    <template v-if="currentUser.referralBy == 50604">
                        Thank you for registering using Shauna Davis' affiliate link, enjoy an
                        additional
                        <span class="font-weight-bolder">20% discount</span> on all Hashtastic
                        packages!
                    </template>

                    <!-- NOTE - Referral by Ben Leavitt -->
                    <template v-if="currentUser.referralBy == 10278">
                        Thank you for registering using Ben Leavitt's affiliate link, enjoy an
                        additional
                        <span class="font-weight-bolder">20% discount</span> on all Hashtastic
                        packages!
                    </template>
                </p>
            </div>
        </div>
    </div>
</template>
<style scoped></style>
<script>
import { mapGetters } from "vuex";
export default {
    name: "affiliateBanner",
    methods: {
        checkIfIsInArrayOfAffiliates() {
            var affiliates = [664, 31847, 23425, 27331, 25620, 75283, 50604, 10278];
            return affiliates.indexOf(this.currentUser.referralBy) > -1;
        },
    },
    mounted() {},
    computed: {
        ...mapGetters({ currentUser: "auth/currentUser" }),
    },
};
</script>
